import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculation"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.70508 20.6676L6.53351 17.8392M6.53351 17.8392L9.36193 15.0107M6.53351 17.8392L3.86561 15.1713M6.53351 17.8392L9.52246 20.8281M3 6.5H6.5M6.5 6.5H10M6.5 6.5V3M6.5 6.5V10M14 6.5L21 6.5M14 18H21M17.5 14.998H17.5039V15.002H17.5V14.998ZM17.5 20.998H17.5039V21.002H17.5V20.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calculation = Vue.extend<IconProps>({
  name: 'CalculationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'calculation',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Calculation;
